import { render, staticRenderFns } from "./UserCardReports.vue?vue&type=template&id=03e4e3eb&scoped=true"
import script from "./UserCardReports.vue?vue&type=script&lang=js"
export * from "./UserCardReports.vue?vue&type=script&lang=js"
import style0 from "./UserCardReports.vue?vue&type=style&index=0&id=03e4e3eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e4e3eb",
  null
  
)

export default component.exports